var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":"https://api.whatsapp.com/send/?phone=966563944455&text=Looking forward to help you!","target":"_blank","rel":"noreferrer nofollow"}},[_c('img',{staticClass:"floating-icon",attrs:{"src":"/assets/icons/wahtsapp.svg"}})])
}]

export { render, staticRenderFns }